import { ReactNode } from 'react';
import { IconClose } from '@/components/svg-symbols/icons';
import { cn } from '@/utils/cn';
import { sendCtaClickEvent } from '../analytics/datalayer/datalayer';
import { CtaClickEventData } from '../analytics/datalayer/types';
import { AppNextLink } from '../app-next-link';
import { Webengage } from '../webengage';
interface Props {
  size: 'large' | 'medium';
  children: ReactNode;
  href?: string;
  disabled?: boolean;
  className?: string;
  onClick?: (e: React.MouseEvent, href: string) => void;
  marketing?: CtaClickEventData;
  iconCloseClassName?: string;
  isActive?: boolean;
  showClose?: boolean;
  sendEvents?: boolean;
}
export const EasyAccess = ({
  size,
  href = '',
  disabled = false,
  children,
  className = '',
  onClick,
  marketing,
  iconCloseClassName,
  isActive = false,
  showClose = true,
  sendEvents = true
}: Props) => {
  const handlePushDataLayer = () => {
    if (!sendEvents) return;
    sendCtaClickEvent({
      elementType: marketing?.elementType ?? '',
      elementIndex: marketing?.elementIndex ?? 0,
      itemID: marketing?.itemID ?? '',
      elementName: marketing?.elementName,
      destinationUrl: href ?? '',
      componentId: marketing?.componentId,
      ImageUrl: null,
      ...(marketing?.term && {
        term: marketing?.term
      })
    });
    Webengage.trackCtaAction({
      banner_type: marketing?.elementType || '',
      banner_name: marketing?.elementName ?? '',
      banner_index: marketing?.elementIndex?.toString() || '0',
      url_destination: href || '',
      item_id: marketing?.itemID || '',
      component_id: marketing?.componentId ?? '',
      image_url: '',
      ...(marketing?.term && {
        term: marketing?.term
      })
    });
  };
  const handleOnClickLink = (e: React.MouseEvent) => {
    handlePushDataLayer();
    onClick?.(e, href);
  };
  const easyAccessClassName = cn('flex w-fit items-center rounded border bg-surface-solid-50 px-2 py-1 text-text-darkGray lg:hover:border-primary-main lg:hover:bg-surface-solid-0', {
    'gap-1 text-body-14': size === 'large',
    'gap-0.5 text-caption-12': size !== 'large',
    'pointer-events-none bg-surface-solid-100 text-text-mediumGray': disabled,
    'border-border-gray-medium': !isActive,
    'border-primary-main': isActive
  }, className);
  return href ? <AppNextLink href={href} prefetch={false} className={easyAccessClassName} onClick={handleOnClickLink} data-sentry-element="AppNextLink" data-sentry-component="EasyAccess" data-sentry-source-file="easy-access.tsx">
            {children}
        </AppNextLink> : <button type='button' className={easyAccessClassName} onClick={e => onClick?.(e, href || '')} data-sentry-component="EasyAccess" data-sentry-source-file="easy-access.tsx">
            {children}

            {showClose && <IconClose className={cn('h-4 w-4', iconCloseClassName)} />}
        </button>;
};